/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Press_IntroInputs */

const en_onboarding_v1_press_intro = /** @type {(inputs: Onboarding_V1_Press_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As seen on`)
};

const de_onboarding_v1_press_intro = /** @type {(inputs: Onboarding_V1_Press_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekannt aus`)
};

const pt_br2_onboarding_v1_press_intro = /** @type {(inputs: Onboarding_V1_Press_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na mídia`)
};

const tr_onboarding_v1_press_intro = /** @type {(inputs: Onboarding_V1_Press_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basında`)
};

const zh_cn2_onboarding_v1_press_intro = /** @type {(inputs: Onboarding_V1_Press_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`媒体报道`)
};

const zh_hk2_onboarding_v1_press_intro = /** @type {(inputs: Onboarding_V1_Press_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`媒體報道`)
};

const ko_kr2_onboarding_v1_press_intro = /** @type {(inputs: Onboarding_V1_Press_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`미디어 소개`)
};

const ru_ru2_onboarding_v1_press_intro = /** @type {(inputs: Onboarding_V1_Press_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`О нас пишут`)
};

const es_419_onboarding_v1_press_intro = /** @type {(inputs: Onboarding_V1_Press_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visto en`)
};

/**
* | output |
* | --- |
* | "As seen on" |
*
* @param {Onboarding_V1_Press_IntroInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_press_intro = /** @type {((inputs?: Onboarding_V1_Press_IntroInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Press_IntroInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_press_intro(inputs)
	if (locale === "de") return de_onboarding_v1_press_intro(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_press_intro(inputs)
	if (locale === "tr") return tr_onboarding_v1_press_intro(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_press_intro(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_press_intro(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_press_intro(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_press_intro(inputs)
	return es_419_onboarding_v1_press_intro(inputs)
});